/**
 * Сводка над полем кода (KAN-610): для какого аккаунта вводится код.
 */
import { normalizePhone } from '@/lib/telegramConnect';

interface Props {
  label: string;
  phone: string;
}

export function ConnectAccountBadge({ label, phone }: Props): JSX.Element {
  const number = normalizePhone(phone);
  return (
    <div
      className="rounded-md border bg-gray-50 px-3 py-2"
      data-testid="connect-account-badge"
    >
      <p className="text-xs text-gray-500">Код вводится для аккаунта:</p>
      <p className="text-base font-semibold">
        {label.trim() && (
          <span data-testid="connect-account-badge-label">
            {label.trim()}{' '}
          </span>
        )}
        <span data-testid="connect-account-badge-phone">{number}</span>
      </p>
    </div>
  );
}
